module.exports = __webpack_public_path__ + "img/mixerTruk-yellow.8497fa00.svg";